module.exports = __webpack_public_path__ + "static/media/tsk-t1.433c58e6.svg";